import store from 'store'
import {
  formatPhoneNumber,
  isStarCode,
  isPhoneNumber,
} from 'n2p-ui-library/utils/phone-number/phone-number.util'
import { IFormatParams } from 'n2p-ui-library/utils/phone-number/phone-number.domain'

// Not used right now
const NATIONAL_FORMAT_COUNTRY_CODES: string[] = []

interface IExtendedFormatParams extends Omit<IFormatParams, 'numberFormat'> {
  numberFormat?: 'simple' | 'national' | 'auto' | IFormatParams['numberFormat']
}

const formatNumber = (params: IExtendedFormatParams = {}): string => {
  const { country } = store.getState().config
  const { numberFormat, ...restParams } = params
  // Different default format for different countries
  const resultingNumberFormat =
    numberFormat || (country.code === 'BR' ? 'simple' : 'auto')

  switch (resultingNumberFormat) {
    case 'simple':
      return String(params.number || '')
    case 'national':
      return formatPhoneNumber({
        country,
        nationalFormat: true,
        ...restParams,
      })
    case 'auto':
    default:
      return formatPhoneNumber({
        country,
        nationalFormat: NATIONAL_FORMAT_COUNTRY_CODES.includes(country.code),
        ...restParams,
      })
  }
}

export { isStarCode, isPhoneNumber }

export default formatNumber
